export const getDepartmentsTableData = (data: string[]) => {
  return data.map((item) => ({
    name: item,
  }));
};
